import { cn } from '@commenda/utils';
import React from 'react';

import { Skeleton } from '../../Skeleton';
import {
  TableBody as TBody,
  TableCell as TCell,
  TableRow as TRow,
} from '../../Table';
import { DATA_GRID_DEFAULT_COLUMN_WIDTH } from '../constants';
import { DataGridClassNames } from '../types';
import { getDataGridColumnMinWidthStyle } from '../utils';
import {
  DATA_GRID_BODY_CELL_CLASS_NAMES,
  DATA_GRID_ROW_HEADER_CELL_CLASS_NAMES,
  DATA_GRID_ROW_SEPARATOR_CLASS_NAMES,
} from './classNames';

export interface DataGridLoadingStateProps {
  columnWidths: number[];
  rowCount: number;
  classNames?: DataGridClassNames;
}

const DataGridLoadingState = ({
  columnWidths,
  rowCount,
  classNames,
}: DataGridLoadingStateProps) => {
  const rowKeys = Array.from(
    { length: rowCount },
    (unusedRow, rowIndex) => `data-grid-loading-row-${rowIndex}`
  );
  const cellKeys = columnWidths.map(
    (unusedWidth, columnIndex) => `data-grid-loading-cell-${columnIndex}`
  );

  return (
    <TBody className={cn('divide-y-0', classNames?.body)}>
      {rowKeys.map((rowKey) => (
        <TRow key={rowKey} className={cn(classNames?.row)}>
          {cellKeys.map((cellKey, columnIndex) => (
            <TCell
              key={`${rowKey}-${cellKey}`}
              style={getDataGridColumnMinWidthStyle(
                columnWidths[columnIndex] ?? DATA_GRID_DEFAULT_COLUMN_WIDTH
              )}
              className={cn(
                columnIndex === 0
                  ? DATA_GRID_ROW_HEADER_CELL_CLASS_NAMES
                  : DATA_GRID_BODY_CELL_CLASS_NAMES,
                DATA_GRID_ROW_SEPARATOR_CLASS_NAMES,
                columnIndex === 0 ? classNames?.rowHeaderCell : classNames?.cell
              )}
            >
              <Skeleton className="h-3 w-3/5" />
            </TCell>
          ))}
        </TRow>
      ))}
    </TBody>
  );
};

export { DataGridLoadingState };
